import { Link } from 'react-router-dom';

export type Crumb = { label: string; to?: string };

export default function Breadcrumbs({ items }: { items: Crumb[] }) {
  return (
    <nav aria-label="面包屑导航" className="flex flex-wrap items-center gap-2 text-xs md:text-sm font-label text-background-200/80">
      <Link to="/" className="hover:text-background-50 transition-colors">首页</Link>
      {items.map((item) => (
        <span key={item.label} className="flex items-center gap-2">
          <i className="ri-arrow-right-s-line text-background-200/50" aria-hidden="true" />
          {item.to ? (
            <Link to={item.to} className="hover:text-background-50 transition-colors">
              {item.label}
            </Link>
          ) : (
            <span className="text-accent-300">{item.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}